<template>
  <div class="bar_wrap">
    <div ref="barcharts" id="barcharts" class="barcharts"></div>
  </div>
</template>
<script>
import echarts from 'echarts'

var option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
      label: {
        show: true
      }
    },
    formatter: function (params) {
      var str = '';
      var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1197b8"></span>'
      //首先要看看params是怎样的数据结构，里面有什么内容;
      //对params进行操作
      params.forEach(item => {
        str += item.name + "</br>" + dotHtml + item.value
      })
      return str
    }
  },
  dataZoom: [{
    start: 0,//默认为0
    end: 100 - 1500 / 31,//默认为100
    type: 'slider',
    show: true,
    xAxisIndex: [0],
    handleSize: 0,//滑动条的 左右2个滑动条的大小
    height: 10,//组件高度
    left: '5%', //左边的距离
    right: '4%',//右边的距离
    bottom: 26,//底边的距离
    borderColor: "#000",
    fillerColor: '#269cdb',
    borderRadius: 5,
    backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
    showDataShadow: false,//是否显示数据阴影 默认auto
    showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
    realtime: true, //是否实时更新
    filterMode: 'filter',
  },
  //下面这个属性是里面拖到
  {
    type: 'inside',
    show: true,
    xAxisIndex: [0],
    start: 0,//默认为1
    end: 100 - 1500 / 31,//默认为100
  },
  ],
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: [],
    axisLabel: {//x轴文字的配置
      show: true,
      textStyle: {
        color: "#888",
      },
      formatter: function (value) {
        var res = value;
        res = res.substring(5, 10)
        return res;
      }


    },

  },
  grid: {
    top: '20px',
    left: '50px'

  },
  yAxis: {
    type: 'value',
    min: 0,
    max: 100,
    axisLabel: {//x轴文字的配置
      show: true,
      textStyle: {
        color: "#888",
      }
    },
    //设置分割线虚线效果
    splitLine: {
      show: true,
      lineStyle: {

        color: "#888",
      },
    },

  },
  series: [
    {
      data: [],
      markPoint: {
        data: [
          {
            type: '`100`' //最大值
          },
          {
            type: '0' //最小值
          }
        ]
      },
      type: 'line',
      areaStyle: {},
      lineStyle: {
        width: 2,
        color: "#3195E6",
      },
      showSymbol: true, //去掉折线上的小圆点
      symbol: 'circle',  //设定为实心点 
      symbolSize: 5,
      color: "rgba(49, 149, 230, 1)",     //设定实线点的颜色
      areaStyle: {//覆盖区域的渐变色
        normal: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              {
                offset: 0, color: 'rgba(49, 149, 230, .8)' // 0% 处的颜色
              },
              {
                offset: 1, color: 'rgba(49, 149, 230, 0)' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          },
        }
      },



    }
  ]
};

export default {
  props: {
    barlist: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  data () {
    return {
    }
  },
  watch: {
    barlist: {
      handler (newValue, oldValue) {
        this.initCharts()
      },
      deep: true,
    },
  },
  methods: {
    initCharts () {
      let charts = this.$echarts.init(this.$refs.barcharts);
      option.xAxis.data = this.barlist.xAxis
      option.series[0].data = this.barlist.series
      charts.setOption(option);
    },
  },
  created () {
    this.$nextTick(() => {
      this.initCharts()
    })
  }
}
</script>
<style lang="scss" scoped>
.barcharts {
  width: 700px;
  height: 410px;
}
</style>